module.exports = __webpack_public_path__ + "static/media/creador-pdf-departamentos-bosque.cd048350.JPG";